import push from '@/utils/gaEvents/push'

import { CATE_CATEGORY, RECOMMAND_CATEGORY } from '@/enums/gtagEvents'

// NOTE: 주차장 탐색 시나리오
const partner = {
  onLoadParkinglotSummary: (
    parkinglotType: CATE_CATEGORY,
    parkinglotSeq: number,
    latitude: number,
    longitude: number
  ) => {
    push({
      event: 'explore_주차장요약',
      page: '주차장요약화면',
      act: '주차장클릭',
      cate: parkinglotType,
      pklSeq: parkinglotSeq,
      lat: latitude,
      lon: longitude
    } satisfies GtagExploreEvent)
  },
  onClickTicketCard: (parkinglotSeq: number, latitude: number, longitude: number) => {
    push({
      event: 'explore_요약_제휴상품상세이동',
      page: '주차장요약화면',
      act: '주차상품클릭',
      pklSeq: parkinglotSeq,
      lat: latitude,
      lon: longitude
    } satisfies GtagExploreEvent)
  },
  onLoadParkinglotDetail: (
    parkinglotType: CATE_CATEGORY,
    parkinglotSeq: number,
    latitude: number,
    longitude: number
  ) => {
    push({
      event: 'explore_주차장상세',
      page: '주차장상세화면',
      act: '주차장상세도달',
      cate: parkinglotType,
      pklSeq: parkinglotSeq,
      lat: latitude,
      lon: longitude
    } satisfies GtagExploreEvent)
  },
  onClickShareButton: (parkinglotType: CATE_CATEGORY, parkinglotSeq: number) => {
    push({
      event: 'explore_공유클릭',
      page: '주차장상세화면',
      act: '주차장전달',
      cate: parkinglotType,
      pklSeq: parkinglotSeq
    } satisfies GtagExploreEvent)
  },
  onClickBackButton: (parkinglotType: CATE_CATEGORY, parkinglotSeq: number) => {
    push({
      event: 'explore_주차장상세뒤로가기',
      page: '주차장상세화면',
      act: 'back',
      cate: parkinglotType,
      pklSeq: parkinglotSeq
    } satisfies GtagExploreEvent)
  },
  onClickRoadViewButton: (parkinglotType: CATE_CATEGORY, parkinglotSeq: number) => {
    push({
      event: 'explore_로드뷰클릭',
      page: '주차장상세화면',
      act: '로드뷰확인',
      cate: parkinglotType,
      pklSeq: parkinglotSeq
    } satisfies GtagExploreEvent)
  },
  onClickNaviButtonInExplore: (parkinglotType: CATE_CATEGORY, parkinglotSeq: number) => {
    push({
      event: 'explore_내비클릭',
      page: '주차장상세화면',
      act: '내비게이션',
      cate: parkinglotType,
      pklSeq: parkinglotSeq
    } satisfies GtagExploreEvent)
  },
  onClickAppBannerButton: (parkinglotType: CATE_CATEGORY, parkinglotSeq: number) => {
    push({
      event: 'explore_앱이동_상세',
      page: '주차장상세화면',
      act: '앱으로이동',
      cate: parkinglotType,
      pklSeq: parkinglotSeq
    } satisfies GtagExploreEvent)
  }
}

const shared = {
  onLoadParkinglotSummary: (shareSeq: number, latitude: number, longitude: number) => {
    push({
      event: 'explore_주차장요약',
      page: '주차장요약화면',
      act: '주차장클릭',
      cate: CATE_CATEGORY.SHARE,
      shareSeq,
      lat: latitude,
      lon: longitude
    } satisfies GtagExploreEvent)
  },
  onLoadParkinglotDetail: (shareSeq: number, latitude: number, longitude: number) => {
    push({
      event: 'explore_주차장상세',
      page: '주차장상세화면',
      act: '주차장상세도달',
      cate: CATE_CATEGORY.SHARE,
      shareSeq,
      lat: latitude,
      lon: longitude
    } satisfies GtagExploreEvent)
  },
  onClickShareButton: (shareSeq: number) => {
    push({
      event: 'explore_공유클릭',
      page: '주차장상세화면',
      act: '주차장전달',
      cate: CATE_CATEGORY.SHARE,
      shareSeq
    } satisfies GtagExploreEvent)
  },
  onClickBackButton: (shareSeq: number) => {
    push({
      event: 'explore_주차장상세뒤로가기',
      page: '주차장상세화면',
      act: 'back',
      cate: CATE_CATEGORY.SHARE,
      shareSeq
    } satisfies GtagExploreEvent)
  },
  onClickRoadViewButton: (shareSeq: number) => {
    push({
      event: 'explore_로드뷰클릭',
      page: '주차장상세화면',
      act: '로드뷰확인',
      cate: CATE_CATEGORY.SHARE,
      shareSeq
    } satisfies GtagExploreEvent)
  },
  onClickNaviButtonInExplore: (shareSeq: number) => {
    push({
      event: 'explore_내비클릭',
      page: '주차장상세화면',
      act: '내비게이션',
      cate: CATE_CATEGORY.SHARE,
      shareSeq
    } satisfies GtagExploreEvent)
  },
  onClickAppBannerButton: (shareSeq: number) => {
    push({
      event: 'explore_앱이동_상세',
      page: '주차장상세화면',
      act: '앱으로이동',
      cate: CATE_CATEGORY.SHARE,
      shareSeq
    } satisfies GtagExploreEvent)
  }
}

const common = {
  onClickMoaiFeedBackButton: (cate: RECOMMAND_CATEGORY, nrSeq: number) => {
    push({
      event: 'explore_모아이피드백버튼클릭',
      page: '주차장상세화면',
      act: '모아이피드백버튼클릭',
      cate: cate,
      nrSeq: nrSeq
    } satisfies GtagExploreEvent)
  },

  onClickRecommendParkinglotCard: (couponSeq: number, parkinglotSeq: number) => {
    push({
      event: 'explore_추천주차장클릭',
      page: '주차장상세화면',
      act: '추천주차장클릭',
      couponSeq,
      pklSeq: parkinglotSeq
    } satisfies GtagExploreEvent)
  }
}

const exploreEvents = {
  partner,
  shared,
  common
}

export default exploreEvents
